module.exports = {"pt-BR":{"admin":{"realEstateAgency":{"index":{"menu":"Menu","agencies":"Imobiliárias","leads":"Leads","leadsKurole":"Leads Kurole"}}}}}